export default {"src":"/_next/static/media/carriage_24.7dc6cf04.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};